import React, { useState } from 'react';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="relative">
            <div className="absolute w-full h-full bg-black opacity-75 translate-y-4"></div>
            <nav className="relative text-lg p-8 bg-white border-t-4 border-b-4 border-black">
                <div className="max-w-screen-xl flex flex-wrap justify-center mx-auto"> 
                    <button onClick={toggleMenu} type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200" aria-expanded={isOpen ? "true" : "false"}>
                        <span className="sr-only">Open main menu</span>
                        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
                        </svg>
                    </button>
                    <div className={`w-full md:block md:w-auto ${isOpen ? 'block' : 'hidden'}`}>
                        <ul className="flex justify-center flex-col md:flex-row md:space-x-12">
                            <li>
                                <a href="https://www.fiverr.com/ben_duffield?public_mode=true" className="font-RedditMono text-black hover:text-blue-700">TWITTER</a>
                            </li>
                            <li>
                                <a href="https://basescan.org/address/0x2e0fc9dba6e31740b6231d7faa00cda89054dd31" className="font-RedditMono text-black hover:text-blue-700">CONTRACT</a>
                            </li>
                            <li>
                                <a href="https://app.uniswap.org/explore/tokens/base/0x2e0fc9dba6e31740b6231d7faa00cda89054dd31" className="font-RedditMono text-black hover:text-blue-700">CHART</a>
                            </li>
                            <li>
                                <a href="https://en.wikipedia.org/wiki/The_Duck_Song" className="font-RedditMono text-black hover:text-blue-700">WHITEPAPER</a>
                            </li>
                            <li>
                                <a href="https://app.uniswap.org/swap?outputCurrency=0x2e0fc9dba6e31740b6231d7faa00cda89054dd31&chain=base" className="font-RedditMono text-black hover:text-blue-700">BUY</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
}

